const blueprintVersion = 'bp5';
export default blueprintVersion;
